import { Icon, IconName, MaybeElement } from "@blueprintjs/core"
import React from "react"
import classNames from "utils/classNames"
import QueryBar from "../Common/QueryBar"

export interface ModuleHeaderProps {
  /**
   * className property is provided as a convience to change the styling of the module if needed
   * also this is only provided at the top level becuase the children can be accessed via css selectors
   * so we don't need to pass a className to all the children
   */
  className?: string
  /**
   * When this option is set true the module header as a traditional white background
   * @default false
   */
  white?: boolean
  /**
   * Properties assigned to the search filter
   */
  query?: string
  onQueryChange?: (e: any) => void
  onQuerySubmit?: (e: any) => void
  filter?: any
  header?: any
  /**
   * The border bottom property, allows the user to blend the component better with the
   * ReactTableHeader
   */
  borderBottom?: string | number | undefined
  searchBar?: boolean
  children?: React.ReactNode
  placeholder?: string
}

const ModuleHeader = ({
  header,
  children,
  white,
  onQueryChange,
  onQuerySubmit,
  query,
  filter,
  className,
  borderBottom,
  searchBar = true,
  placeholder = "Search...",
}: ModuleHeaderProps) => {
  return (
    <section
      style={{
        borderBottom,
      }}
      className={classNames(
        "vt-module-header p-3",
        {
          "vt-module-header-white": white,
        },
        className
      )}
    >
      <div className="vt-module-description">{header}</div>
      {searchBar ? (
        <div className="vt-search-filter">
          <QueryBar
            onChange={onQueryChange}
            onSubmit={onQuerySubmit}
            value={query ?? ""}
            round={false}
            className="vt-module-header-query-bar"
            placeholder={placeholder}
          />
          {filter}
        </div>
      ) : (
        ""
      )}
      <div className="vt-module-accessories">{children}</div>
    </section>
  )
}

export interface DescriptionProps {
  /**
   * Specifies the title for the particular module
   */
  title: string
  /**
   * The icon which briefly describes the type of the module,
   * This comes from the blueprint property
   */
  icon: IconName | MaybeElement
}
export const Description = ({ icon, title }: DescriptionProps) => {
  return (
    <>
      <Icon icon={icon} />
      <span className="ml-2 vt-text">{title}</span>
    </>
  )
}
export default ModuleHeader
